import { useState } from "react";
import { useLocation } from "@tanstack/react-router";
import { Button } from "~/components/ui/button";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardFooter,
} from "~/components/ui/card";
import { Dialog, DialogTrigger } from "~/components/ui/dialog";
import { DonateModal } from "./DonateModal";

export function DonateCard() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  // Language detection (same pattern as AboutCard/ProjectsCard)
  const getLanguage = () => {
    const segments = location.pathname.split("/").filter(Boolean);
    const langs = ["uz", "ru", "en"];
    return langs.includes(segments[0]) ? segments[0] : "oz";
  };

  // Multi-language content
  const content = {
    "uz-Latn": {
      title: "Homiylik",
      description:
        "Lotin.uz rivojlanishiga hissa qo'shgan quyidagi insonlarga katta rahmat!",
      buttonText: "Siz ham hissa qo'shing!",
    },
    "uz-Cyrl": {
      title: "Хомийлик",
      description:
        "Lotin.uz ривожланишига ҳисса қўшган қуйидаги инсонларга катта раҳмат!",
      buttonText: "Сиз ҳам ҳисса қўшинг!",
    },
    ru: {
      title: "Пожертвования",
      description:
        "Огромное спасибо следующим людям, которые внесли свой вклад в развитие Lotin.uz!",
      buttonText: "Поддержать проект!",
    },
    "en-US": {
      title: "Donate",
      description:
        "Big thanks to the following people who contributed to the development of Lotin.uz!",
      buttonText: "Contribute too!",
    },
  };

  const langMap: Record<string, keyof typeof content> = {
    oz: "uz-Latn",
    uz: "uz-Cyrl",
    ru: "ru",
    en: "en-US",
  };

  const currentLang = getLanguage();
  const currentContent = content[langMap[currentLang]] || content["uz-Latn"];

  return (
    <Card className="shrink-0">
      <CardHeader>
        <CardTitle>{currentContent.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p>{currentContent.description}</p>
      </CardContent>
      <CardFooter>
        <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
          <DialogTrigger asChild>
            <Button className="w-full">
              {currentContent.buttonText}
            </Button>
          </DialogTrigger>
          {isModalOpen && <DonateModal onClose={() => setIsModalOpen(false)} />}
        </Dialog>
      </CardFooter>
    </Card>
  );
}
